export default "__VITE_ASSET__Ctp5TwgG__"